<div [ngClass]="{ inline: inline, block: !inline }">
  <img src="assets/images/flags/dailyUp-loader.svg" alt="loading" />
</div>
